<template>
  <div class="tips__wrapper" v-if="order && isParentAccount">
    <v-list two-lines v-if="!tipped && visibleTips">
      <v-list-tile v-on="onTip" ripple class="tips__content">
        <v-list-tile-action class="tips__icon">
          <SvgIcon width="32" height="32" icon="TipForDriver" />
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="font-weight-bold">{{
            $t('record.tip_for_driver.not_tip.title')
          }}</v-list-tile-title>
          <v-list-tile-sub-title class="black--text">{{
            $t('record.tip_for_driver.not_tip.desc')
          }}</v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action class="tips__btn">
          <v-btn icon>
            <v-icon color="#697077">chevron_right</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>

    <v-list two-lines v-if="tipped">
      <v-list-tile v-on="visibleTips ? onTip : {}" :ripple="visibleTips" class="tips__content">
        <v-list-tile-action class="tips__icon">
          <SvgIcon width="32" height="32" icon="TipForDriver" />
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="font-weight-bold">{{
            $t('record.tip_for_driver.do_tip.title')
          }}</v-list-tile-title>
          <v-list-tile-sub-title class="caption black--text"
            >{{ $t('record.tip_for_driver.do_tip.desc') }}
            <span class="font-weight-bold body-2 ml-1">{{
              `${$constants.CURRENCY_CONFIG.prefix}${
                typeof tipAmount === 'string'
                  ? tipAmount.toLocaleString()
                  : parseInt(tipAmount).toLocaleString()
              }`
            }}</span></v-list-tile-sub-title
          >
        </v-list-tile-content>
        <v-list-tile-action
          v-if="visibleTips"
          class="tips__btn__tip-more font-weight-bold subheading ml-3"
          >{{ $t('record.tip_for_driver.tip_more') }}</v-list-tile-action
        >
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const TIP_EXPIRED_TIME = 3 * 24 * 60 * 60 // 72 hours

export default {
  name: 'TipForDriver',
  props: {
    order: {
      type: Object
    },
    onTip: {
      type: Object
    }
  },
  data() {
    return {
      tipAmount: 0
    }
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.user.profile
    }),
    tipped() {
      return this.tipAmount > 0
    },
    visibleTips() {
      if (
        this.order.status === this.$constants.ORDER_STATUS.COMPLETED ||
        this.order.status === this.$constants.ORDER_STATUS.CANCELLED
      ) {
        const time =
          this.order.status === this.$constants.ORDER_STATUS.COMPLETED
            ? this.$moment.unix(this.order.complete_time)
            : this.$moment.unix(this.order.cancel_time)
        const diff = this.$moment().diff(time, 'seconds')
        console.log(this.$route.query.tip_expired, diff)

        if (this.$route.query.tip_expired) {
          // TODO: this condition's only applied for testing and will remove before release
          if (diff < parseInt(this.$route.query.tip_expired) * 60 * 60) return true
        } else if (diff < TIP_EXPIRED_TIME) {
          return true
        }
      }
      return false
    },
    isParentAccount() {
      return (
        this.userProfile && (!this.userProfile.parent_id || this.userProfile.parent_id === 'null')
      )
    }
  },
  mounted() {
    if (this.order && this.order.path && this.order.path[0] && this.order.path[0].tips) {
      this.order.path[0].tips.forEach((tip) => (this.tipAmount = this.tipAmount + tip.amount))
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.tips__wrapper {
  padding: 0 14px;
  margin-bottom: -8px;

  .v-list {
    padding: 0;
  }

  .tips__content {
    overflow: hidden;
    background-color: #fff2ea;
    border-radius: 6px;

    .v-list__tile {
      height: 100%;
      padding: 14px 16px;
      overflow: hidden;

      &__sub-title {
        white-space: normal;
      }

      &__content {
        flex-grow: 1;
      }

      &__action {
        min-width: 0;
        flex: none;

        &.tips {
          &__icon {
            margin-right: 16px;
          }

          &__btn {
            margin-left: 16px;
          }

          &__btn__tip-more {
            color: #ea5800;
          }
        }
      }
    }
  }
}
</style>
